<template>
  <div
    style="background-color: #f0f9fd;
    border-radius: 15px;
    padding: 15px"
  >
    <b-row style="margin-top: 15px">
      <b-col>
        <b-link
          style="{display: block }"
          size="sm"
          @click="handleEditToggle"
          class="mt-2"
        >
        </b-link>
        <delete
          class="float-right"
          style="margin-left: 15px;"
          :profile="profile"
          :heartbeat="heartbeat"
          :info="info"
          :apps="apps"
          :doc="doc"
          :section-id="sectionId"
          :plan-id="planid"
        />
        <iona v-if="profile" class="float-right" :profile="profile" />
      </b-col>
    </b-row>
    <b-row style="margin-top: 5px">
      <b-col sm="7">
        <texts
          class="float-right"
          :profile="profile"
          :heartbeat="heartbeat"
          :texts="careCardTexts"
        />
      </b-col>
      <b-col>
        <calendar
          class="float-right"
          style="margin-left: 15px"
          :profile="profile"
          :heartbeat="heartbeat"
          :info="info"
          :apps="apps"
          :doc="doc"
          :section-id="sectionId"
          :plan-id="planid"
        />
        <track-care
          class="float-right"
          :profile="profile"
          :heartbeat="heartbeat"
          :info="info"
          :apps="apps"
          :doc="doc"
          :section-id="sectionId"
          :plan-id="planid"
        />
        <signature
          :profile="profile"
          :heartbeat="heartbeat"
          :info="info"
          :apps="apps"
          :doc="doc"
          :section-id="sectionId"
          :plan-id="planid"
        />
      </b-col>
    </b-row>
    <hr />
    <b-row style="margin-top: 15px">
      <b-col>
        <feedback
          style="margin-left: 15px;"
          :profile="profile"
          :heartbeat="heartbeat"
          :info="info"
          :apps="apps"
          :doc="doc"
          :section-id="sectionId"
          :plan-id="planid"
        />
      </b-col>
      <b-col>
        <timeline
          style="margin-left: 15px;"
          :profile="profile"
          :heartbeat="heartbeat"
          :info="info"
          :apps="apps"
          :doc="doc"
          :section-id="sectionId"
          :plan-id="planid"
        />
      </b-col>
      <b-col>
        <automation
          v-if="false"
          :profile="profile"
          :heartbeat="heartbeat"
          :info="info"
          :apps="apps"
          :doc="doc"
          :section-id="sectionId"
          :plan-id="planid"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Iona from "@/components/common/iona";
import Texts from "./texts";
import Signature from "./signature";
import Automation from "./automation";
import Feedback from "./feedback";
import Timeline from "./timeline";
import Calendar from "./calendar";
import TrackCare from "./track";
import Delete from "./delete";
export default {
  name: "HeartBeat_CarePlan_Block",
  components: {
    Iona,
    Texts,
    Feedback,
    Signature,
    Timeline,
    Calendar,
    TrackCare,
    Delete,
    Automation
  },
  created() {},
  beforeMount() {},
  mounted() {},
  props: {
    careCard: {
      type: Object,
      default: () => {
        return {};
      }
    },
    heartbeat: {
      type: Object,
      required: true,
      default: () => {
        return {};
      }
    },
    profile: {
      type: Object,
      required: true,
      default: () => {
        return {};
      }
    },
    doc: {
      type: Object,
      default: () => {
        return {};
      }
    },
    apps: {
      type: Array,
      required: true,
      default: () => {
        return [];
      }
    },
    section: {
      type: Object,
      required: false,
      default: () => {
        return {};
      }
    },
    planid: {
      type: String,
      required: false,
      default: null
    }
  },
  computed: {
    ...mapGetters({}),
    careCardTexts() {
      return this.careCard &&
        this.careCard.texts &&
        Array.isArray(this.careCard.texts)
        ? this.careCard.texts
        : [];
    },
    sectionText() {
      return this.info && Array.isArray(this.info)
        ? this.info.join(" ")
        : this.info;
    }
  },
  methods: {
    handleEditToggle() {
      debugger;
      this.isEditMode != this.isEditMode;
    }
  },
  data() {
    return {
      info:
        this.section && this.section.info && Array.isArray(this.section.info)
          ? this.section.info
          : [this.section.info],
      sectionId: this.section && this.section.id ? this.section.id : "none",
      carePlanDocId: this.doc && this.doc.id ? this.doc.id : null,
      isEditMode: false
    };
  }
};
</script>

<style lang="scss" scoped>
.container .vue-grid-item.vue-grid-placeholder {
  background: #c0c081;
}
</style>
